export const SEND_TO_ENGINEER = 'sendmail.toEngineer'
export const SEND_TO_VENDOR = 'sendmail.toVendors'
export const SEND_EMAIL = 'sendmail'
export const emailSeparator = ';'
